import { hasOngoingEuIncident, hasOpenEuIncidentInHistory } from "../utils/elevenLabsEuIncidents";

// Both public endpoints of https://status.elevenlabs.io are served with CORS "*". The widget
// API is the one incident.io documents; the Statuspage-compatible one also carries every
// update text. Querying both means neither a format change nor an outage of one breaks detection.
export const ELEVENLABS_WIDGET_URL = "https://status.elevenlabs.io/api/v1/summary";
export const ELEVENLABS_INCIDENTS_URL = "https://status.elevenlabs.io/api/v2/incidents.json";

// Without a timeout a stalled request would block every later poll of useKeepLiveRefresh.
export const ELEVENLABS_REQUEST_TIMEOUT_MS = 10_000;

const fetchJson = async (url: string): Promise<unknown> => {
    const response = await fetch(url, {
        cache: "no-store",
        signal: AbortSignal.timeout(ELEVENLABS_REQUEST_TIMEOUT_MS),
    });
    if (!response.ok) {
        throw new Error(`ElevenLabs status request to ${url} failed with ${response.status}`);
    }
    return response.json();
};

const elevenLabsStatusService = {
    async fetchHasEuDisruption(): Promise<boolean> {
        const results = await Promise.allSettled([
            fetchJson(ELEVENLABS_WIDGET_URL).then(hasOngoingEuIncident),
            fetchJson(ELEVENLABS_INCIDENTS_URL).then(hasOpenEuIncidentInHistory),
        ]);
        const answers = results.flatMap(result => result.status === "fulfilled" ? [result.value] : []);
        if (answers.length === 0) {
            throw new Error("ElevenLabs status page is unreachable");
        }
        return answers.some(Boolean);
    },
};

export default elevenLabsStatusService;
